import { Title, Text } from '@tremor/react';
import { FC, HTMLAttributes } from 'react';
import s from './ConnectorRadioButton.module.scss';

interface Props extends HTMLAttributes<HTMLInputElement> {
  label: string;
  description: string;
  name: string;
  value: string;
  defaultChecked?: boolean;
  type?: 'radio' | 'checkbox';
}

export const ConnectorRadioButton: FC<Props> = ({
  description,
  label,
  className,
  style,
  type = 'radio',
  ...rest
}) => {
  return (
    <label
      className={[s.label, type === 'checkbox' ? s.checkboxType : '', className].join(
        ' ',
      )}
      style={style}
    >
      <input type={type} {...rest} />
      <section className={s.radioSection}>
        <Title className={s.radioTitle}>{label}</Title>
        <Text className={s.radioDescription}>{description}</Text>
      </section>
    </label>
  );
};
